"use strict";
/**
 * @packageDocumentation
 * @module harmony-core
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlType = void 0;
var UrlType;
(function (UrlType) {
    UrlType[UrlType["http"] = 0] = "http";
    UrlType[UrlType["ws"] = 1] = "ws";
})(UrlType = exports.UrlType || (exports.UrlType = {}));
//# sourceMappingURL=types.js.map